<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">{{ project.employerProjectNumber }} · Standort</p>
      <h2 class="presentation-page__title">
        Lage: {{ locationZip }} - {{ project.employerProjectNumber }}
      </h2>
      <p class="presentation-page__text">
        Standortübersicht — kein Verschattungsproblem.
      </p>
      <div
        class="presentation-page__body presentation-page__body--split presentation-page__body--split-two-thirds"
      >
        <div class="presentation-page__column presentation-page__column--media">
          <figure class="presentation-page__figure">
            <img
              v-if="propertyImageSrc"
              class="presentation-page__image"
              :src="propertyImageSrc"
              :alt="$t('shortTeaserPrintPage3_propertyPhotoAlt')"
            />
            <div v-else class="presentation-page__image-placeholder" aria-hidden="true"></div>
          </figure>
          <p class="presentation-page__image-caption bg-blue">
            Aufnahme des Objekts · {{ locationZip }} {{ locationCity }}
          </p>
        </div>
        <div class="presentation-page__column presentation-page__column--text">
          <div class="presentation-page__meta-panel">
            <div class="presentation-page__meta-panel-header">Standortdaten</div>
            <div
              v-for="row in locationData"
              :key="row.label"
              class="presentation-page__meta-panel-row"
            >
              <span class="presentation-page__meta-panel-label">{{ row.label }}</span>
              <span class="presentation-page__meta-panel-value">{{ row.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

/** Matches {@link PROJECT_ATTACHMENT_TYPES.SHORT_TEASER_PROPERTY_IMAGE} on the server */
const SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE = 'SHORT_TEASER_PROPERTY_IMAGE';

export default {
  name: 'MasterPresentationPrintPage34',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {
    locationZip() {
      return this.resolveLocationZipAndCity().zip;
    },

    locationCity() {
      return this.resolveLocationZipAndCity().city;
    },

    locationData() {
      return [
        { label: 'PLZ/Ort', value: `${this.locationZip} ${this.locationCity}` },
        { label: 'Anlagentyp', value: 'Dachfläche' },
        { label: 'Verschattung', value: 'Keine relevante' },
        { label: 'Netzanschluss', value: 'Bestätigt' },
        { label: 'Baugenehmigung', value: 'Nicht erforderlich' },
      ];
    },

    propertyImageSrc() {
      const attachments = this.project?.attachments;
      if (!Array.isArray(attachments) || attachments.length === 0) {
        return '';
      }

      const propertyImages = attachments.filter(
        (attachment) => attachment.attachmentType === SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE
      );
      if (propertyImages.length === 0) {
        return '';
      }

      return this.attachmentSrcPreferFullResolution(propertyImages[0]);
    },
  },
  methods: {
    resolveLocationZipAndCity() {
      const project = this.project;
      if (!project) {
        return { zip: '', city: '' };
      }

      const useInstallationZipAndCity =
        project.installationAddressState === 'YES' && project.installationAddress;

      if (useInstallationZipAndCity) {
        return {
          zip: String(project.installationAddress.zip ?? '').trim(),
          city: String(project.installationAddress.city ?? '').trim(),
        };
      }

      const customer = project.customer;
      if (!customer) {
        return { zip: '', city: '' };
      }

      return {
        zip: String(customer.zip ?? '').trim(),
        city: String(customer.city ?? '').trim(),
      };
    },

    sanitizeAttachmentPath(path) {
      if (!path || typeof path !== 'string') {
        return '';
      }
      if (path.indexOf('https://') !== 0) {
        return 'https://' + path;
      }
      return path;
    },

    attachmentSrcPreferFullResolution(attachment) {
      if (!attachment) {
        return '';
      }
      if (attachment.path) {
        return this.sanitizeAttachmentPath(attachment.path);
      }
      if (attachment.thumbnail) {
        return this.sanitizeAttachmentPath(attachment.thumbnail);
      }
      return '';
    },
  },
};
</script>
